<template>
  <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="modalTitle" aria-modal="true">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title">Załączniki do artykułu</h5>
          <button type="button" class="btn-close" @click="$emit('close')"></button>
        </div>

        <div class="modal-body">

          <div v-if="article.files.length">
            <ul class="list-group mb-4">
              <li v-for="file in article.files" :key="file.id"
                  class="list-group-item d-flex justify-content-between align-items-center">
                <a :href="route('articles.files.show', {file:file.id})" target="_blank">
                  {{ file.original_name }}
                </a>
                <button v-if="canRemove && hasPermission('canEditArticles')" class="btn btn-sm btn-danger"
                        @click="deleteFile(file.id)">Usuń
                </button>
              </li>
            </ul>
          </div>
          <div v-else class="alert alert-warning">
            Brak załączników.
          </div>

          <form v-if="canAdd && hasPermission('canEditArticles')" @submit.prevent="uploadFile" class="mt-3">
            <div class="mb-3">
              <label for="file" class="form-label">Dodaj załącznik (max 10MB)</label>
              <input class="form-control" type="file" id="file" @change="handleFileChange">
            </div>
            <button class="btn btn-primary" :disabled="!selectedFile">Wyślij</button>
          </form>

        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="$emit('close')">Zamknij</button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {useForm} from '@inertiajs/vue3';
import {usePermission} from "@/composables/resources/js/composables/permissions.js";

const {hasPermission} = usePermission();

export default {
  props: {
    article: Object,
    canAdd: {type: Boolean, default: true},
    canRemove: {type: Boolean, default: true},
  },

  emits: ['refresh', 'added-success', 'added-error', 'close'],

  data() {
    return {
      hasPermission,
      selectedFile: null,
      fileForm: useForm({
        file: null
      })
    }
  },

  methods: {
    handleFileChange(event) {
      this.selectedFile = event.target.files[0]
      this.fileForm.file = this.selectedFile
    },

    uploadFile() {
      if (!this.fileForm.file || !this.article?.id) return

      this.fileForm.post(route('articles.files.store', {article: this.article.id}), {
        forceFormData: true,
        preserveScroll: true,
        onSuccess: (response) => {
          this.selectedFile = null
          this.reloadFiles();
          this.$emit('added-success', response.props.flash.success);
          this.$emit('refresh', true);
          this.fileForm.reset();
        },
        onError: (error) => {
          console.log(error);
          this.$emit('added-error', error.props.flash.error)
        }
      })
    },

    deleteFile(fileId) {
      if (!this.article?.id || !fileId) return

      this.fileForm.delete(route('articles.files.destroy', {
        article: this.article.id,
        file: fileId
      }), {
        preserveScroll: true,
        onSuccess: (response) => {
          this.reloadFiles();
          this.$emit('added-success', response.props.flash.success);
          this.$emit('refresh', true);
        },
        onError: (error) => {
          console.log(error);
          this.$emit('added-error', error.props.flash.error)
        }
      })
    },

    reloadFiles() {
      axios.get(route('article.files.index', {article: this.article.id}))
          .then(response => {
            this.article.files = response.data.files
          })
          .catch(error => {
            console.error('Nie udało się załadować załączników:', error)
          })
    },
  }
}
</script>


<style scoped>
.modal.show {
  display: block;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
